module.exports = __webpack_public_path__ + "img/round_yellow.png";